import { render, staticRenderFns } from "./showAddonComponent.vue?vue&type=template&id=be1e0cae"
import script from "./showAddonComponent.vue?vue&type=script&lang=js"
export * from "./showAddonComponent.vue?vue&type=script&lang=js"
import style0 from "./showAddonComponent.vue?vue&type=style&index=0&id=be1e0cae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports